"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPreSanitizeOperation = exports.isPostSanitizeOperation = void 0;
const NoTypeDefinitionOperations = [
    'attachHeader',
    'xlsx2csv',
    'pdf2csv',
    'preFilter',
    'unzip',
];
// operations that produced sanitized tapes. TapeBuilderTaskWithTapeDefinition
const PostSanitizeOperations = [
    // 'asset2json', // this is a json task, should this be included here?
    'sanitize',
    'filter',
    'join',
    'edit',
    'xlsx2csv2',
    'stack',
    'flatten',
];
const isPostSanitizeOperation = (operation) => {
    return PostSanitizeOperations.includes(operation);
};
exports.isPostSanitizeOperation = isPostSanitizeOperation;
const isPreSanitizeOperation = (operation) => {
    return NoTypeDefinitionOperations.includes(operation);
};
exports.isPreSanitizeOperation = isPreSanitizeOperation;
//# sourceMappingURL=tasks.js.map